import { TreeNodeInfo } from "@blueprintjs/core"
import { ID } from "src/libs/interfaces/layouts"
import { getContrastColor } from "src/libs/utilities"
import { ILanding, ILandingCategory } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface ICategoryTreeItemProps {
   category: ILandingCategory
   categories: ID[]
   onClick: (cat: ILandingCategory) => void
}
const getCategoryTreeItem = (props: ICategoryTreeItemProps): TreeNodeInfo => {
    const is = !!props.categories.find( ( id: ID ) => id === props.category.id )
    return {
        id: props.category.id,
        className: "p-0",
        label: <span 
            className="cti smallest letter-spacing-2 px-2 py-0" 
            style={{ 
                color: is ? getContrastColor( props.category.color ) : undefined, 
                backgroundColor: is ? props.category.color: undefined,

            }} 
            onClick={ () => props.onClick( props.category ) }
        >
            { props.category.title } 
        </span>,
        isExpanded: true,
        hasCaret: false,
        childNodes: getTreeItem( props.category,  props.onClick, props.categories )
    }
}
export default getCategoryTreeItem


export const getTreeItem = (category: ILandingCategory, onClick: (cat: ILandingCategory) => void, categories: ID[] ): TreeNodeInfo[] => {
    const landing: ILanding = useLandingStore.getState().currentLanding
    const cats: TreeNodeInfo[] = ( landing.categories || [] )
        .filter( c => c.parentId === category.id )
        .map(c => {            
            const is = !!categories.find( ( id: ID ) => id === c.id )
            return {
                id: c.id,
                className: "p-0",
                label: <span 
                    className="cti smallest letter-spacing-2 px-2 py-0" 
                    style={{ 
                        color: is ? getContrastColor( c.color ) : undefined, 
                        backgroundColor: is ? c.color: undefined,
                    }} 
                    onClick={ () => onClick( c ) }
                >
                    { c.title }
                </span>,
                isExpanded: true, 
                hasCaret: false,
                childNodes: getTreeItem( c,  onClick, categories )
            }
        })
    return cats
}